module.exports = __webpack_public_path__ + "img/logo_panel-white.c41c91c4.svg";